import { createApp } from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
require("@/assets/css/main.scss");
import Toast, { PluginOptions } from "vue-toastification";
import "vue-toastification/dist/index.css";
import { plugin as VueTippy } from "vue-tippy";
import { createMetaManager } from "vue-meta";
// import "tippy.js/dist/tippy.css"; // optional for styling

const app = createApp(App).use(store).use(router).use(createMetaManager());
app.use(
  VueTippy,
  // optional
  {
    directive: "tippy", // => v-tippy
    component: "tippy", // => <tippy/>
    componentSingleton: "tippy-singleton", // => <tippy-singleton/>
  }
);
const toastOptions: PluginOptions = {
  // You can set your default options here
};
app.use(Toast, toastOptions);
app.mount("#app");
